// Utils and Service
import { getErrorMessage, isCanceledError } from '../utils/helpers'

// eslint-disable-next-line import/no-cycle
import axios from './instance'

/**
 * Fetches the site-wide announcements targeted to the current user.
 * Response is a plain array (the endpoint disables pagination).
 * @param {func} setLoading
 * @param {func} setError
 * @param {AbortSignal} signal - cancels the request when a newer one supersedes it
 */
export const getAnnouncements = async (
  setLoading = () => {},
  setError = () => {},
  signal = undefined,
) => {
  setLoading(true)

  try {
    const data = await axios.get('/announcements/', { signal })
    setLoading(false)
    return data
  } catch (err) {
    // Superseded by a newer request; leave loading state for the in-flight one.
    if (isCanceledError(err)) return null

    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

/**
 * Dismisses an announcement banner for the current user (also marks it read).
 * @param {string} announcementId
 * @param {func} setLoading
 * @param {func} setError
 * @param {func} setSuccess
 */
export const dismissAnnouncement = async (
  announcementId,
  setLoading = () => {},
  setError = () => {},
  setSuccess = () => {},
) => {
  setLoading(true)

  try {
    const response = await axios.post(`/announcements/${announcementId}/dismiss/`)
    setLoading(false)
    setSuccess(true)
    return response
  } catch (err) {
    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

/**
 * Marks an announcement as read for the current user.
 * @param {string} announcementId
 * @param {func} setLoading
 * @param {func} setError
 * @param {func} setSuccess
 */
export const markAnnouncementAsRead = async (
  announcementId,
  setLoading = () => {},
  setError = () => {},
  setSuccess = () => {},
) => {
  setLoading(true)

  try {
    const response = await axios.post(`/announcements/${announcementId}/mark-as-read/`)
    setLoading(false)
    setSuccess(true)
    return response
  } catch (err) {
    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

/**
 * Marks every announcement targeted to the current user as read.
 * @param {func} setLoading
 * @param {func} setError
 * @param {func} setSuccess
 */
export const markAllAnnouncementsAsRead = async (
  setLoading = () => {},
  setError = () => {},
  setSuccess = () => {},
) => {
  setLoading(true)

  try {
    const response = await axios.post('/announcements/mark-all-as-read/')
    setLoading(false)
    setSuccess(true)
    return response
  } catch (err) {
    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}
